// src/pages/Errors/NotFound.tsx
import { Callout, Flex ,Heading,Text} from '@radix-ui/themes';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
    return (
        <Flex direction="column">
            <Callout.Root color="red" role="alert">
                    <Heading title='404 - Página Não Encontrada'>
                    404 - Página Não Encontrada
                    </Heading>
                 
                    <Text   title='Desculpe, a página que você está procurando não existe.'>
                             Desculpe, a página que você está procurando não existe.
                    </Text>
                    <Link to="/" style={{ color: 'var(--gray-12)' }}>Voltar para o Dashboard</Link>
            </Callout.Root>

        </Flex>
    );
};

export default NotFound;